import {
    RetrieveCategory,
    RetrieveProductTemplate,
    RetrieveProductTemplateRes,
} from '@ortros/stoux-lib'
import { HttpResponse } from 'nexus-res'

import axios from '@/core/axios'
import { ListProductByTemplateRes } from 'stoux-shared-types/services/product-template'

export type ProductTemplateStaticGen = {
    barcode: string
    handle: string
}

export class ProductTemplateRepository {
    public async listStaticGenTemplates(): Promise<ProductTemplateStaticGen[]> {
        const { data } = await axios.get<{
            templates: ProductTemplateStaticGen[]
        }>('/templates', {
            params: {
                staticGen: true,
            },
        })

        return data.templates
    }

    public async getProductTemplateById(
        id: string,
    ): Promise<RetrieveProductTemplate> {
        const { data } = await axios.get<HttpResponse<RetrieveProductTemplate>>(
            `/templates/${id}`,
        )
        return data.metadata!
    }

    public async getProductTemplateByHandle(
        handle: string,
    ): Promise<RetrieveProductTemplate> {
        const { data } = await axios.get<HttpResponse<RetrieveProductTemplate>>(
            `/templates/${handle}`,
        )
        return data.metadata!
    }

    public async getProductTemplateProducts(
        barcode: string,
    ): Promise<ListProductByTemplateRes> {
        const { data } = await axios.get<
            HttpResponse<ListProductByTemplateRes>
        >(`/templates/${barcode}/products`)
        return data.metadata!
    }

    public async getProductTemplateCategories(
        handle: string,
    ): Promise<RetrieveCategoryWithDepth[]> {
        const { data } = await axios.get<
            HttpResponse<RetrieveCategoryWithDepth[]>
        >(`/templates/${handle}/category`)
        return data.metadata!
    }

    public async getNewProductTemplates(): Promise<RetrieveProductTemplate[]> {
        const { data } =
            await axios.get<HttpResponse<RetrieveProductTemplateRes>>(
                '/templates/new',
            )
        return data.metadata?.templates!
    }
}

type RetrieveCategoryWithDepth = {
    depth: number
} & RetrieveCategory
